import React from 'react';
import classnames from 'classnames';
import './Modal.css';
import PropTypes from 'prop-types';


const Modal = (props) => {
  return (
    <div
      className={classnames('modal fade', {
        'show': props.show
      })}
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-background" onClick={props.toggleModalState}></div>
      <div className="modal-dialog" role="document" style={{ minWidth: props.minWidth }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">{props.title}</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span
                aria-hidden="true"
                onClick={props.toggleModalState}
              >&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
}


Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  toggleModalState: PropTypes.func.isRequired,
  minWidth: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

Modal.defaultProps = {
  minWidth: 0
}


export default Modal;



// WEBPACK FOOTER //
// ./src/components/common/Modal/Modal.js